import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { ChevronLast, CircleCheck, Newspaper, Plus } from "lucide-react";
import { useNotification } from "../../../components/notification/NotificationContainer";
import ContactDonorCompleted from "../ContactDonorCompleted";
import {
  donorProposalEmailCompleted,
  donorProposalFollowUpEmailCompleted,
  getProject,
} from "../../../features/projectsSlice";
import MainContainer from "../../../components/container/MainContainer";
import Modal from "../../../components/modal/Modal";
import TextContainer from "../../../components/text/TextContainer";
import { closeModal, openModal } from "../../../features/modalSLice";
import { getEmailedDonors, unsetDonors } from "../../../features/donorsSlice";
import { useLayoutEffect } from "react";
import Loading from "../../../components/loading/Loading";
import PageTitle from "../../../components/titles/PageTitle";
import useCustomBackButton from "../../../hooks/useCustomBackButton";
import IncludeDonor from "./IncludeDonor";
import ContactDonorFollowUpCompleted from "../ContactDonorFollowUoCOmpleted";
import loadStatus from "../../../util/loadStatus";
import NetworkError from "../../error/NetworkError";

const ProjectFollowUpList = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const addNotification = useNotification();
  const modalContent = useSelector((state) => state.modal.content);
  const project = useSelector((state) => state.projects.selected);
  const projectLoad = useSelector((state) => state.projects.load.getProject);
  const donors = useSelector((state) => state.donors.data);
  const donorsLoad = useSelector((state) => state.donors.load.getDonors);

  //When done Mailing or recording
  const onSubmit = async (data) => {
    try {
      const res = await dispatch(donorProposalFollowUpEmailCompleted(id));
      if (donorProposalFollowUpEmailCompleted.fulfilled.match(res)) {
        addNotification("Email Sending Completed", "success");
        dispatch(closeModal());
        navigate(-1);
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  const onHandleCompletedModal = () => {
    dispatch(openModal(<ContactDonorFollowUpCompleted id={id} />));
  };

  const handleIncludeDonorClick = () => {
    dispatch(openModal(<IncludeDonor id={id} donors={donors || []} />));
  };

  const getAllData = useCallback(async () => {
    const allData = await Promise.all[
      (dispatch(getProject(id)),
      dispatch(getEmailedDonors({ id, data: { required: true } })))
    ];
  }, []);

  useCustomBackButton("/projects/reformulations");
  useLayoutEffect(() => {
    // if (!project.id || (project.id && project.id !== id)) {
    //   dispatch(getProject(id));
    // }
    // dispatch(getEmailedDonors({ id, data: { required: true } }));
    getAllData();
    return () => {
      dispatch(unsetDonors());
    };
  }, []);

  useLayoutEffect(() => {
    if (
      (project.id && project?.stage?.step_number < 13) ||
      (project.id && project?.stage?.step_number > 13)
    ) {
      return navigate("/projects/reformulations", { replace: true });
    }
  }, [project, navigate]);

  if (projectLoad === loadStatus.loading || donorsLoad === loadStatus.loading) {
    return <Loading />;
  }

  if (projectLoad === loadStatus.error || donorsLoad === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer className="">
      <Modal>{modalContent}</Modal>
      {project.id ? (
        <>
          <PageTitle title="Follow Up Mail To Donors" />
          <div className="sm:flex justify-between items-center p-5 border border-bkg2 bg-bkg rounded-md mb-5">
            <div className="mb-5 sm:mb-0">
              <TextContainer label="Title" content={project.name} />
              <TextContainer
                label="Location"
                content={project.project_location}
              />
              <TextContainer label="Community" content={project.community} />
            </div>
            <div className=" flex gap-2">
              <button
                onClick={handleIncludeDonorClick}
                className="add-rss-btn text-center"
              >
                Include Donor
                <Plus size={18} />
              </button>
              <button
                onClick={onHandleCompletedModal}
                className="add-rss-btn text-center"
              >
                Done Sending
                <ChevronLast size={18} />
              </button>
            </div>
          </div>
          <main className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3">
            {donors.map((item, index) => (
              <div
                key={index}
                className="p-5 rounded-md bg-content shadow flex flex-col"
              >
                <Link
                  className="text-lg text-primary/80 font-bold hover:text-primary flex  items-center justify-between"
                  to={"/reformulations/donors/follow-up/" + item.id + "/" + id}
                >
                  {item.name} <Newspaper size={20} />
                </Link>
                <div className="p-3 bg-bkg border border-bkg2 rounded-md my-3">
                  <TextContainer label="Email" content={item.email} />
                  <TextContainer label="Phone" content={item.phone} />
                  <TextContainer label="Adress" content={item.address1} />
                  <TextContainer label="Country" content={item.country} />
                </div>
                <div className="p-3">
                  {item.sentMails.some((item) => item.type === "follow up") && (
                    <CircleCheck className="text-green-500" />
                  )}
                </div>
              </div>
            ))}
          </main>
        </>
      ) : (
        <Loading />
      )}
    </MainContainer>
  );
};

export default ProjectFollowUpList;
